import { Component, OnInit,ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';//para pasar datos de regreso desde aca del modal
import * as firebase from 'firebase'
import { AngularFireFunctions } from '@angular/fire/functions';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-modal-acciones-usuario',
  templateUrl: './modal-acciones-usuario.component.html',
  styleUrls: ['./modal-acciones-usuario.component.scss']
})
export class ModalAccionesUsuarioComponent implements OnInit {



  usuario=null;
  procesodeEliminarActivo=false
  procesodeAutoridadActivo=false
  alertaActiva=false;
  tipodeAlerta='primary'
  mensajeAlerta=''
  trabajando=false
  regional=''
  autoridadAislante=false
  autoridadArea=false
  autoridadAreaLocal=false
  autoridadHSE=false
  gerenteRegional=false
  botondisabled=true


  constructor(public activeModal: NgbActiveModal, private functions: AngularFireFunctions) { }

  ngOnInit(): void {
  }

  cerrar(parametro){
    this.activeModal.close(parametro);//esto no lo estamos usando pero es para tenerlo ahi 
  }

  confirmaEliminar(){
    this.procesodeEliminarActivo=true
  }
  cancelarEliminar(){
    this.procesodeEliminarActivo=false
  }
  confirmaPromover(){
    this.procesodeAutoridadActivo=true
  }
  cancelarPromover(){
    this.procesodeAutoridadActivo=false
  }


eliminarCuenta(idParaEliminar){

  this.trabajando=true
  this.alerta("warning","eliminando usuario...")

  // Use the function name from Firebase
  const callable = this.functions.httpsCallable('deleteUser');

  // Create an Observable and pass any data you want to the function
  const obs = callable({id: idParaEliminar});

  obs.subscribe( res => {

      if(res.result =="OK"){

        //despues de eliminada la cuenta, se elimina de la coleccion de users y despues de la de autoridades
        firebase.firestore().collection("users").doc(idParaEliminar).delete().then(()=>{
          
          this.procesodeEliminarActivo=false
            this.alerta("success","Usuario eliminado con éxito!")
            this.cerrar("OK")
          
        }).catch((err)=>{
          this.alerta("danger",err)
          this.cerrar(err)
        })
      }else
      if(res.result !="OK"){
        this.cerrar(res.result)
        this.alerta("danger",res.result)
        console.log("RESPUESTA DE LA FUNCION: "+res.result)
        this.procesodeEliminarActivo=false
      }
  });

}

PromoverAautoridad(usuario){
  this.trabajando=true
  this.alerta("warning","Convirtiendo en autoridad...")

  firebase.firestore().collection("autoridades").doc(usuario.id).set({
    autoridadAislante: this.autoridadAislante,
    autoridadArea:this.autoridadArea,
    autoridadAreaLocal:this.autoridadAreaLocal,
    autoridadHSE:this.autoridadHSE,
    gerenteRegional:this.gerenteRegional,
    email:usuario.data().email,
    id:usuario.id,
    nombre:usuario.data().nombre,
    regional:this.regional
  }).then(() => {
    this.procesodeAutoridadActivo=false
    this.alerta("success","Usuario convertido en autoridad")
    this.cerrar("OK")
  }).catch((err) => {
      this.procesodeAutoridadActivo=false
      this.alerta("danger",err)
      this.cerrar("OK")
    });
}


alerta(tipo,input){
  this.alertaActiva=true;
  this.mensajeAlerta=input;
  this.tipodeAlerta=tipo;
}



closeAlert(){
  this.alertaActiva=false
}

validaboton(){
  console.log("validaboton activado")
    if( (this.regional !='') && (this.autoridadAislante ==true || this.autoridadArea ==true || this. autoridadAreaLocal ==true|| this.autoridadHSE ==true || this.gerenteRegional ==true ) ){this.botondisabled=false}
    if  (this.regional =='') {this.botondisabled=true}
    if (this.autoridadAislante ==false && this.autoridadArea ==false && this. autoridadAreaLocal ==false&& this.autoridadHSE ==false && this.gerenteRegional ==false){this.botondisabled=true}
}



}//fin de clase
